import { $lastRewardFromCase } from '@/entities/cases'
import { RewardClaim } from '@/widgets/boxes/rewardClaim'
import { useUnit } from 'effector-react'

export const RewardPageView = () => {
  const lastRewardFromCase = useUnit($lastRewardFromCase)
  return <RewardClaim key={lastRewardFromCase.timestamp} />
}
